export const LOCALISATION_ADMIN = 'admin';
export const LOCALISATION_CONFIGURATION = 'configuration';
export const CONTROLE_YIELD = 'ControleYield';
export const QUADRA_ADMIN = 'quadraadmin';
